module.exports = __webpack_public_path__ + "static/media/MarinaWeber.43645e28.jpeg";